module.exports = __webpack_public_path__ + "static/media/bag.6946f316.png";